import { useDroppable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'

function getRenderer(field) {
  console.log(field)
  if (field.type === 'spacer') {
    return () => {
      return <div className="spacer">spacer</div>
    }
  }

  if (!field.component) {
    return () => <div>No renderer found for {field.type}</div>
  }

  return field.component
}

export function Field(props) {
  const { field, overlay, ...rest } = props
  const Component = getRenderer(field)

  let className = 'canvas-field'
  if (overlay) {
    className += ' overlay'
  }

  return (
    <div className={className}>
      <Component {...rest} />
    </div>
  )
}

function SortableField(props) {
  const { id, index, field } = props

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      data: {
        index,
        id,
        field,
      },
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Field field={field} />
    </div>
  )
}

export default function Canvas(props) {
  const { fields } = props

  const { listeners, setNodeRef, transform, transition } = useDroppable({
    id: 'canvas_droppable',
    data: {
      parent: null,
      isContainer: true,
    },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} className="canvas" style={style} {...listeners}>
      <div className="canvas-fields">
        {fields?.map((field, index) => (
          <SortableField
            key={field.id}
            id={field.id}
            field={field}
            index={index}
          />
        ))}
      </div>
    </div>
  )
}
